"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageUploadButton = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Spinner_1 = __importDefault(require("@opsbase/web-ui/Spinner"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const debounce_1 = __importDefault(require("lodash/debounce"));
const react_1 = __importStar(require("react"));
const uuid = __importStar(require("uuid"));
const makeMyClasses = uploadButtonStyle => ({
    uploadButton: Object.assign({ cursor: 'pointer', display: 'inline-block', padding: '6px 16px', borderRadius: 6, minWidth: 132, minHeight: 28, textAlign: 'center', color: lib_palette_1.default.secondary.contrastText, backgroundColor: lib_palette_1.default.secondary.main, transition: 'backgroundColor 0.4s', '&:hover': {
            backgroundColor: lib_palette_1.default.secondary.dark,
        } }, uploadButtonStyle),
});
function ImageUploadButton(props) {
    const { onUpload, onUploading, children, uploadButtonStyle } = props;
    const uniqueId = (0, react_1.useRef)(uuid.v4());
    const [uploading, setUploading] = (0, react_1.useState)(false);
    const myCss = (0, web_css_1.default)(makeMyClasses, [uploadButtonStyle]);
    const _doSetUploading = (0, react_1.useMemo)(() => onOff => {
        setUploading(onOff);
        onUploading === null || onUploading === void 0 ? void 0 : onUploading(onOff);
    }, [onUploading]);
    const _doUploadImage = (0, react_1.useMemo)(() => (0, debounce_1.default)((image) => __awaiter(this, void 0, void 0, function* () {
        const reader = new FileReader();
        reader.onload = (e) => __awaiter(this, void 0, void 0, function* () {
            const dataUrl = e.target.result;
            const newImage = new Image();
            newImage.onload = () => {
                const canvas = document.createElement('canvas');
                const resizeCanvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                const resizeCtx = resizeCanvas.getContext('2d');
                canvas.width = newImage.width;
                canvas.height = newImage.height;
                ctx.drawImage(newImage, 0, 0);
                const scale = 1; // image.width > maxWidth ? maxWidth / image.width : 1
                const scaleW = newImage.width * scale;
                const scaleH = newImage.height * scale;
                resizeCanvas.width = scaleW;
                resizeCanvas.height = scaleH;
                resizeCtx.drawImage(canvas, 0, 0, scaleW, scaleH);
                _doSetUploading(false);
                onUpload(resizeCanvas.toDataURL('image/png'), image.name);
            };
            newImage.src = dataUrl;
            //document.getElementById(uniqueId.current).value = null
        });
        reader.readAsDataURL(image);
    }), 1000, { trailing: true, leading: false }), [_doSetUploading, onUpload]);
    const handleClickUpload = (0, react_1.useCallback)(e => {
        _doSetUploading(true);
        _doUploadImage(e.target.files[0]);
        e.target.value = null;
    }, [_doSetUploading, _doUploadImage]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("label", { className: myCss.uploadButton, htmlFor: uniqueId.current },
            react_1.default.createElement("input", { accept: 'image/*', style: { display: 'none' }, id: uniqueId.current, type: "file", onChange: handleClickUpload }),
            uploading && react_1.default.createElement(Spinner_1.default, { size: 14, inline: true, busy: true, color: lib_palette_1.default.White }),
            !uploading && (children !== null && children !== void 0 ? children : react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('upload-image'))))));
}
exports.ImageUploadButton = ImageUploadButton;
exports.default = ImageUploadButton;
